export default {
  "content": "<path d=\"M15.707 20.207c-.98.98-2.384 1.418-3.707 1.418s-2.727-.438-3.707-1.418l1.414-1.414c.52.52 1.366.832 2.293.832.926 0 1.773-.312 2.293-.832l1.414 1.414z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13 6h4a1 1 0 011 1c0 1.377-.682 2.653-1.802 3.571 2.501.698 5.107 2.147 6.674 4.94A1.001 1.001 0 0122 17H2a1.001 1.001 0 01-.872-1.49C2.694 12.719 5.3 11.27 7.8 10.572 6.68 9.653 6 8.377 6 7a1 1 0 011-1h4V2h2v4zm-1 6c-2.449 0-5.84.682-8.031 3H20.03c-2.192-2.318-5.583-3-8.031-3zM8.25 8c.49.993 1.684 1.92 3.51 1.995L12 10l.24-.005C14.066 9.92 15.26 8.993 15.75 8H8.251z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};